import { formularioPedidoStyles } from './FormularioPedido.styles'

export function formularioPedidoIO() {
  return {
    styles: formularioPedidoStyles
  }
}

export type FormularioPedidoIO = ReturnType<typeof formularioPedidoIO>
